import React, { useEffect, useState } from 'react'
import CompDatePicker from '../components/compDatePicker/_CompDatePicker'
import { Dropdown, MenuProps } from 'antd'
import Footer from '../_Footer'
import { Customer, CustomerDocumentModelItem } from '../models/superbit-api-models';
import { CustomerCardModel } from '../models/CustomerCardModel';
import ClientDocument from './documents/_ClientDocument';
import { get, has } from 'lodash';
import UploadDocumentPopUp from './documents/_UploadDocumentPopUp';
import ClientFolderDocuments from './documents/_ClientFolderDocuments';
import MessegePopup from '../subscribers/popups/_MessegePopup';
import EditFolderInfoPopUp from './_EditFolderInfoPopUp';
import './_ClientFiles.css';
import { RootState } from '../app-context/store';
import { useDispatch, useSelector } from 'react-redux';
import { setReloadFilesData } from '../app-context/filesSlice';
import ImportDocumentsPopUp from './documents/ImportDocumentsPopUp';

interface PoliciesDocumentsClientDetailsProps {
    customerId: string;
    documentsList: CustomerDocumentModelItem[];
    setLoading: Function;
    documentsAllData?: number;
    displayClientDocument?: (fileUrl: string) => void;
    showAddTreatmentPopup: (type: number) => void;
}


const PoliciesDocumentsClientDetails: React.FC<PoliciesDocumentsClientDetailsProps> = (props: PoliciesDocumentsClientDetailsProps) => {

    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const dispatch = useDispatch();
    const [documentsFilter, setDocumentsFilter] = useState<any>({
        page: 1,
        customerId: props.customerId,
        searchTerm: '',
        from: undefined,
        to: undefined
    });

    const [documentsList, setDocumentsList] = useState<CustomerDocumentModelItem[]>([...props.documentsList]);
    const [documentsAllData, setDocumentsAllData] = useState<number>(props.documentsAllData ? props.documentsAllData : 0);
    const [showModelUploadDocument, setShowModelUploadDocument] = useState<{ show: boolean, customerId: string }>({ show: false, customerId: '' });
    const [documentsPagerConf, setDocumentsPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    const [documentsSearchText, setDocumentsSearchText] = useState<string>()
    const [documentsTimeoutId, setDocumentsTimeoutId] = useState<number | any | null>(undefined);
    const [apiUrl, setApiUrl] = useState<string>('');

    const [foldersList, setFoldersList] = useState<any[]>([]);

    const [showPopUpMessage, setShowPopUpMessage] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const [hasNewDocument, setHasNewDocument] = useState<boolean>(false);

    const [showImportDocumentPopUp, setShowImportDocumentPopUp] = React.useState<boolean>(false);

    const [showEditFolderPopUp, setShowEditFolderPopUp] = React.useState<{ folderid: string, show: boolean }>({ folderid: '', show: false });

    const reloadFilesData = useSelector((state: RootState) => state.files.reloadFilesData);


    useEffect(() => {
        const savedApiUrl = localStorage.getItem('apiUrl');
        if (savedApiUrl) {
            setApiUrl(savedApiUrl)
        }
        getDocuments(documentsFilter);
        getFolders();
    }, [])

    useEffect(() => {
        if (reloadFilesData) {
            getFolders();
            getDocuments(documentsFilter);
            // Reset the reload flag in the store
            // Assuming you have an action to reset it, e.g., setReloadFilesData(false)
            dispatch(setReloadFilesData(false));
        }
    }, [reloadFilesData])

    // get folders

    const getFolders = async () => {
        props.setLoading(true);
        const foldersData: any = await customerCardModel.customerDocumentsGetFoldersForCustomer(props.customerId);
        // console.log('getFolders', foldersData);
        if (foldersData && foldersData.length > 0) {
            setFoldersList(foldersData);
            setDocumentsAllData(foldersData.length);

        }
        props.setLoading(false);
    }


    // documents
    const getDocuments = async (filter?: any) => {
        props.setLoading(true);
        if (!filter) {
            filter = documentsFilter;
        }
        setDocumentsList([]);
        const documentsData: any = await customerCardModel.customerDocumentsFilter(filter);
        if (documentsData && documentsData.length > 0) {
            const documents = documentsData.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
            setDocumentsList(documents);
        }
        props.setLoading(false);
    }


    const showUploadDocument = () => {
        setShowModelUploadDocument({
            show: true,
            customerId: props.customerId
        });
    }

    const handleDocumentsSearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setDocumentsSearchText(newSearchText);
        // console.log('handleSearchChange', leadsTimeoutId, newSearchText, event);
        const newFilter = documentsFilter;
        newFilter.searchTerm = newSearchText;
        setDocumentsFilter(newFilter);
        clearTimeout(documentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            getDocuments(newFilter);
        }, 1000);
        setDocumentsTimeoutId(newTimeoutId);
    };

    const onDocumentsDateChange = (d: Date, name: string) => {
        // setTreatmentsStartDate(d);
        const newFilter = documentsFilter;
        newFilter[name] = d;
        setDocumentsFilter(newFilter);
        getDocuments(newFilter);
    }

    const clearDocumentsFilter = () => {
        const filter: any = {
            page: 1,
            customerId: props.customerId,
            searchTerm: '',
            from: undefined,
            to: undefined
        }
        setDocumentsFilter(filter);
        getDocuments(filter)
    }


    const onFirstPageClickOnDocuments = (page: number) => {
        const filter = {
            page: 1,
            customerId: props.customerId
        }
        const newFilter = documentsPagerConf;
        newFilter.currentPage = 1
        setDocumentsPagerConf(newFilter);
        setDocumentsFilter(filter);
        getDocuments(filter);
    }

    const nextPageOnDocuments = (page: number) => {
        const filter = {
            page: page,
            customerId: props.customerId
        }
        console.log('nextPageOnDocuments-filter', filter)
        const newFilter = documentsPagerConf;
        newFilter.pageSize = page
        setDocumentsPagerConf(newFilter);
        setDocumentsFilter(filter);
        getDocuments(filter);
    }

    const addPolicyOptions: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <li className="pointer rtl"
                    onClick={() => showUploadDocument()}
                >
                    <label htmlFor="file">{"הוספת מסמך"}</label>
                    {/* <button className="btn btn-primary" onClick={() =>showUploadDocument() }>הוספת מסמך</button> */}
                    {/* <input type="file" id="file" name="file" onChange={showUploadDocument} style={{ display: 'none' }} /> */}
                </li>
            ),
        },
        {
            key: '2',
            label: (
                <li className="pointer rtl"
                    onClick={() => {
                        setShowImportDocumentPopUp(true)
                        
                    }}
                >
                    <label htmlFor="file">{"יבוא מסמך"}</label>
                </li>
            ),
        }
    ];

    const onClose = () => {
        setShowPopUpMessage(false);
        getFolders();
        getDocuments();
    }

    const loadData = () => {
        getFolders();
        getDocuments();
    }


    return (
        <>
            {
                showPopUpMessage &&
                <MessegePopup
                    message={message}
                    statusMessege='success'
                    show={showPopUpMessage}
                    onClose={onClose}

                />
            }

            {showEditFolderPopUp.show &&
                <EditFolderInfoPopUp
                    folderList={foldersList}
                    folderId={showEditFolderPopUp.folderid}
                    onClose={() => {
                        setShowEditFolderPopUp({ folderid: '', show: false });
                        setMessage('תיקייה עודכנה בהצלחה');
                        setShowPopUpMessage(true);
                        getFolders();
                    }}
                    customerId={props.customerId}
                />
            }


            {
                showModelUploadDocument.show &&
                <UploadDocumentPopUp
                    onClose={() => {
                        setShowModelUploadDocument({ show: false, customerId: '' })
                        if (hasNewDocument) {
                            setMessage('מסמך נוסף בהצלחה')
                            setShowPopUpMessage(true);
                            setHasNewDocument(false);
                        }
                    }}
                    config={{ customerId: showModelUploadDocument.customerId }}
                    fromPolicy={"0"}
                    relationType={-1}
                    onSetHasNewDocument={() => setHasNewDocument(true)}
                />
            }

            {showImportDocumentPopUp &&
                <ImportDocumentsPopUp />
                }
            <div className="">
                <div className='flex-space-between'>
                    <div className="filter-row flex-centered client-search">
                        <div className="filter-input search">
                            <input type="text" value={documentsFilter.searchTerm} placeholder="חיפוש" onChange={handleDocumentsSearchChange} />
                            <div className="icon search"></div>
                        </div>
                        <div className="filter-input select">
                            <CompDatePicker value={documentsFilter.from ? documentsFilter.from : null} onChange={(date: Date) => onDocumentsDateChange(date, 'from')} />
                            {/* (date: Date) => onDateChange('identityIssueDate', date) */}
                        </div>
                        <div className="filter-input select">
                            <CompDatePicker value={documentsFilter.to ? documentsFilter.to : null} onChange={(date: Date) => onDocumentsDateChange(date, 'to')} />
                            {/* (date: Date) => onDateChange('identityIssueDate', date) */}
                        </div>
                        <div className="filter-button">
                            <div className="icon refresh-counter pointer" onClick={clearDocumentsFilter}></div>
                        </div>
                    </div>

                    <div className='flex-centered'>
                        <Dropdown menu={{ items: addPolicyOptions }}>
                            <button type="button" className="button blue has-icon flex-centered flex-justify-center">
                                <div className="icon add"></div>
                                הוסף מסמך
                            </button>
                        </Dropdown>
                        <div className="icon gear"></div>
                    </div>
                </div>
                <div className="client-files-header-section" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div style={{ width: '50px' }}>

                    </div>
                    {/* <div className="cell document-icon">
                            
                            </div> */}
                    <div style={{ width: '170px' }}>
                        שם הקובץ
                    </div>
                    <div style={{ width: '250px' }}>
                        שיוך
                    </div>
                    <div style={{ width: '170px' }}>
                        נושא
                    </div>
                    <div style={{ width: '170px' }}>
                        הערות
                    </div>
                    <div style={{ width: '170px' }}>
                        גודל
                    </div>
                    <div style={{ width: '170px' }}>
                        נוצר ע"י
                    </div>
                    <div style={{ width: '170px' }}>
                        תאריך ההוספה
                    </div>

                    <div style={{ width: '170px' }}>
                        {/* קובץ  */}
                    </div>
                </div>
                {/* <div style={{ height: 'calc(100vh - 400px)', overflowY: 'auto' }}>
                    {documentsList ? (<>
                        {documentsList.map((document: CustomerDocumentModelItem) => {
                            return (
                                <ClientDocument
                                    key={document.id}
                                    documentDetails={document}
                                    config={{
                                        apiUrl: apiUrl,
                                        displayFile: props.displayClientDocument ? props.displayClientDocument : (fileUrl: string) => { },
                                    }}
                                />
                            )
                        })}
                    </>) : (<></>)}
                    </div> */}
                <div style={{ height: 'calc(100vh - 400px)', overflowY: 'auto' }}>
                    {
                        foldersList && foldersList.length > 0 &&
                        foldersList.map((folder: any, index: any) => {
                            if (documentsList.filter((doc: any) => doc.customerDocumentFolderId == folder.id).length > 0) {
                                return (
                                    <div key={index}>
                                        <ClientFolderDocuments
                                            folder={folder}
                                            documentsList={documentsList.filter((doc: any) => doc.customerDocumentFolderId == folder.id)}
                                            apiUrl={apiUrl}
                                            displayClientDocument={props.displayClientDocument ? props.displayClientDocument : (fileUrl: string) => { }}
                                            loadData={loadData}
                                            showEditFolderPopUp={(folderId: string) => {
                                                setShowEditFolderPopUp({ folderid: folderId, show: !showEditFolderPopUp.show });
                                            }}
                                            showAddTreatmentPopup={props.showAddTreatmentPopup}

                                        />
                                    </div>
                                )
                            }
                        })
                    }
                    {
                        documentsList.filter((doc: any) => !doc.customerDocumentFolderId || doc.customerDocumentFolderId == null).map((document: any) => {
                            return (
                                <ClientDocument
                                    key={document.id}
                                    documentDetails={document}
                                    config={{
                                        apiUrl: apiUrl,
                                        displayFile: props.displayClientDocument ? props.displayClientDocument : (fileUrl: string) => { },
                                    }}
                                    loadData={loadData}
                                    showAddTreatmentPopup={props.showAddTreatmentPopup}
                                />
                            )
                        })

                    }
                </div>

                {/* <div className="content-body client-documents-list">
                    {documentsList ? (<>
                        {documentsList.map((document: any) => {
                            return (
                                <>
                                    <ClientDocument documentDetails={document} config={{
                                        apiUrl: apiUrl,
                                        displayFile: props.displayClientDocument ? props.displayClientDocument : (fileUrl: string) => { },
                                    }} />
                                </>
                            )
                        })}
                    </>) : (<></>)}
                </div> */}
                {/* <footer className="footer emails-list-footer emails-list-view">
                        <Pagger pagerConf={documentsPagerConf} changePage={emptyFunc} refresh={emptyFunc}></Pagger>
                    </footer> */}

                <Footer allRowsDataNumber={documentsAllData} AllRowsCounter={documentsAllData ? documentsAllData  : 0} rowsInPage={50} currentPage={documentsPagerConf.currentPage ? documentsPagerConf.currentPage : 1}
                    onFirstPageClick={(number: number) => onFirstPageClickOnDocuments(number)}
                    onLastPageClick={(number: number) => nextPageOnDocuments(number)}
                    onNextPageClick={(number: number) => nextPageOnDocuments(number)}
                    onPrevPageClick={(number: number) => nextPageOnDocuments(number)}
                />
            </div>
        </>
    )
}

export default PoliciesDocumentsClientDetails